import { SECURITY_GROUPS_RETRIEVAL_FAILED } from './security.action';

const addToDataLayer = data => window.dataLayer.push(data);

export const securityGroupsAnalytics = {
  [SECURITY_GROUPS_RETRIEVAL_FAILED]: action => addToDataLayer({
    event: 'failure',
    data: JSON.stringify(action.payload)
  })
};
